<template>
  <o-loading
    :full-page="false"
    :active="isLoading"
    :can-cancel="false"
  ></o-loading>
  <div class="list-tab is-border-radius-sm p-2 order-details is-clipped">
    <div class="column card-tab-details">
      <div class="columns">
        <div class="column is-4">
          <div class="tabs-veritcal">
            <div
              v-for="(tab, index) in tabs"
              :key="index"
              class="tab-item"
              :class="{ active: activeTabIndex === index }"
              @click="setData(index)">
              <div
                class="tab-icon is-pulled-left is-flex is-align-items-center is-justify-content-center"
              >
                <i :class="getIcon(tab)" class="has-text-white"></i>
              </div>
              <h3
                class="has-text-black-bis is-size-3 has-text-weight-bold line-height"
              >
                {{ getModule(tab) }}
              </h3>
              <p class="is-size-5 has-text-black-bis">{{ getSubTitle(tab) }}</p>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="tab-content has-background-grey-lighter is-border-radius-sm">
            <div class="column">
              <div class="columns is-multiline">
                <div class="column grouped-buttons is-12 is-flex is-align-items-center is-justify-content-end" v-if="dataLoaded">
                  <button
                    class="button px-0 has-text-dark"
                    @click="openActivityLog"
                  >
                    <i class="icon-activityhistory"></i>
                  </button>
                    <div class="is-divider-vertical mx-0" v-if="!isDisabledOnPermission"></div>
                  <div
                    v-if="!editMode && !isDisabledOnPermission"
                    class="is-flex is-justify-content-flex-end"
                  >
                    <button
                      class="button px-0 has-text-dark"
                      @click="setEditMode(true)"
                    >
                      <i class="icon-edit"></i>
                    </button>
                  </div>
                  <div class="is-flex is-justify-content-flex-end" v-else-if="editMode">
                    <button
                      class="mr-2 button has-text-weight-bold has-background-white is-outlined is-size-4 p-0"
                      @click="setEditMode(false)"
                    >
                      <i class="icon-close has-text-black-bis"></i>
                    </button>
                    <button
                      class="button has-text-weight-bold has-background-black-bis has-text-white is-size-4 p-0"
                      @click="save"
                    >
                      <i class="icon-checkmark has-text-white"></i>
                    </button>
                  </div>
                </div>
                <div class="column">
                  <mf-table
                    v-if="dataLoaded"
                    ref="orderRoute"
                    :tableProps="alteredTableCols"
                    tableName="orderRouting"
                    :loadData="getData"
                    :apiMode="false"
                    :hideGutter="true"
                    :key="activeTabIndex + rerenderKey"
                  >
                    <template #newStage="{ rowData: item }">
                      <span class="perm-desc is-capitalized">{{
                        item.stage
                      }}</span>
                    </template>
                    <template #newLocation="{ rowData: item }">
                      <div class="field">
                        <mf-multi-select
                          v-model="item.newLocation"
                          :options="locationList"
                          group-values="val"
                          group-label="key"
                          label="name"
                          placeholder="(No Change)"
                          :disabled="
                            item.stage === 'coordination' || !item.isEditing
                          "
                          :searchable="true"
                          track-by="_id"
                          :hideSelected="false"
                        ></mf-multi-select>
                      </div>
                    </template>
                    <template #newOwner="{ rowData: item }">
                      <div class="field">
                        <mf-multi-select
                          v-model="item.newOwner"
                          :options="ownerList"
                          :closeOnSelect="true"
                          label="name"
                          track-by="_id"
                          :multiple="false"
                          :hideSelected="false"
                          placeholder="(No Change)"
                          :disabled="!item.isEditing"
                        ></mf-multi-select>
                      </div>
                    </template>
                    <template #notify="{ rowData: item }">
                      <div class="order-routing-notify" :class="item?.notify?.length > 1 ? '' : 'is-flex is-align-items-center'">
                      <VueMultiselect
                        v-if="item.isEditing"
                        v-model="item.notify"
                        :options="ownerList"
                        :closeOnSelect="true"
                        label="name"
                        track-by="_id"
                        :multiple="true"
                        placeholder="(Nobody)"
                        :hideSelected="false"
                      ></VueMultiselect>
                      <span
                        v-else
                        class="is-size-3 has-text-weight-normal ml-1 has-text-black-bis"
                      >
                        {{ $_.map(item.notify, "name").join(", ") }}
                      </span>
                      </div>
                    </template>
                  </mf-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <activity-log
      :id="activityDetail.id"
      :projectId="activityDetail.projectId"
      :isActive="isActivityLogOpen"
      :orderName="activityDetail.orderName"
      @update:isActive="isActivityLogOpen = false"
      :type = "module"
    ></activity-log>
</template>
<script>
import { reactive, toRefs, ref, computed, onBeforeMount, onMounted} from "vue";
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { cloneDeep, filter, groupBy, map, pullAllBy, findIndex, isEmpty } from "lodash";
import Projects from "@/models/Projects";
import Locations from "@/models/Locations";
import MfTable from "@/components/table-fields/MfTable.vue";
import VueMultiselect from "vue-multiselect";
import ActivityLog from '@/components/ActivityLog.vue';
import PermissionMixin from '@/components/mixins/PermissionMixin';

export default {
  name: "OrderRouting",
  props: {
    rowData: Object,
  },
  components: {
    MfTable,
    VueMultiselect,
    ActivityLog
  },
  setup(props, { emit }) {
    const store = useStore();
    const toast = useToast();

    const data = reactive({
      tabs: [],
      project: {},
      ownerList: [],
      tableData: [],
      rerenderKey: 0,
      editMode: false,
      locationList: [],
      isLoading: false,
      activeTabIndex: 0,
      dataLoaded: false,
       activityDetail: {
        id: '',
        projectId: '',
        orderName: '',
      },
      isActivityLogOpen: false,
    });

    const { getPermissionValues } = PermissionMixin();

    const moduleArrayMap = {
      MaterialOrders: {
        title: "Material Orders",
        icon: "icon-materialmanager",
        subTitle: "Define and edit routing for Material Orders"
      },
      ProdOrders: {
        title: "Basic Production Orders",
        icon: "icon-productionmanager",
        subTitle: "Define and edit routing for Basic Production Orders"
      },
      AssemblyProdOrders: {
        title: "Assembly Production Orders",
        icon: "icon-productionmanager",
        subTitle: "Define and edit routing for Assembly Production Orders"
      },
      KitProdOrders: {
        title: "Kit Production Orders",
        icon: "icon-attachedkitsOL",
        subTitle: "Define and edit routing for Kit Production Orders"
      },
      TransferRequest: {
        title: "Transfer Requests",
        icon: "icon-transferrequestOL",
        subTitle: "Define and edit routing for Transfer Requests"
      },
    };

    const routeFields = [
      {
        title: "New Stage",
        width: "296px",
        id: "stage",
        name: "newStage",
        prop: "stage",
        cardProps: {
          isEditing: false,
        },
      },
      {
        title: "Request Type",
        width: "152px",
        id: "reqType",
        name: "newStage",
        alwaysVisible: true,
        prop: "stage",
        dataClass: "overflow-visible",
      },
      {
        title: "New Owner",
        width: "296px",
        id: "owner",
        name: "newOwner",
        alwaysVisible: true,
        prop: "newOwner",
        dataClass: "overflow-visible",
      },
      {
        title: "New Location",
        width: "296px",
        id: "newLocation",
        name: "newLocation",
        alwaysVisible: true,
        prop: "newLocation",
        dataClass: "overflow-visible",
      },
      {
        title: "Notify",
        width: "400px",
        id: "notify",
        name: "notify",
        alwaysVisible: true,
        prop: "notify",
        dataClass: "overflow-visible",
      },
    ];

    const getModule = (module) => {
      const moduleName = module.name;
      return moduleArrayMap[moduleName].title;
    };

    const getIcon = (module) => {
      const moduleName = module.name;
      return moduleArrayMap[moduleName].icon;
    };
    const getSubTitle = (module) => {
      const moduleName = module.name;
      return moduleArrayMap[moduleName].subTitle;
    }

    const buildTabsAndData = () => {
      const route = groupBy(data.project.orderRoute, "module");
      let groupedRoute = map(route, (v, module) => ({
        name: module,
        stages: v,
      }));
      groupedRoute = groupedRoute.filter((routeData) => {
        const title = getModule(routeData).toLowerCase();
        return title.includes(store.state.queryParams.searchText.toLowerCase());
      });
      data.tabs = [...groupedRoute];
    };

    onBeforeMount(async () => {
      try {
        data.isLoading = true;
        data.project = _.cloneDeep(props.rowData)
        data.project = await Projects.getOne(props.rowData._id);
        data.ownerList = await Projects.linkedProjectUsers([props.rowData._id]);
        data.locationList = await Locations.allLocationForUser({
          project: props.rowData._id,
        });
        data.locationList = Locations.groupLocations(
          data.locationList,
          store.state.companyData
        );
        data.ownerList = filter(
          data.ownerList,
          (owner) => owner.company === data.project.createdCompany._id
        );
        // build tabs object
        buildTabsAndData();
        data.dataLoaded = true;
      } catch (e) {
        console.error("Error: ", e);
      } finally {
        data.isLoading = false;
      }
    });

    const getData = () => {
      data.tableData = [];
      data.tableData = cloneDeep(data.tabs[data.activeTabIndex].stages);
      return data.tableData;
    };

    const setData = (index) => {
      data.activeTabIndex = index;
      if (data.editMode) data.editMode = false;
    };

    const alteredTableCols = computed(() => {
      const taskReqCols = cloneDeep(routeFields);
      const selectedData = data.tabs[data.activeTabIndex].stages;
      if (selectedData[0].module === "TransferRequest") {
        return {
          fields: pullAllBy(
            taskReqCols,
            [{ id: "stage" }, { id: "newLocation" }],
            "id"
          ),
        };
      }
      return { fields: pullAllBy(taskReqCols, [{ id: "reqType" }], "id") };
    });

    const setEditMode = async (val) => {
      data.editMode = val;
      data.tableData.forEach((row) => {
        row.isEditing = val;
      });
      if (!val) {
        data.rerenderKey++;
      }
    };

    const save = async () => {
      try {
        data.isLoading = true;
        // const route = this.data[rowIndex];
        const route = data.tabs[data.activeTabIndex];
        route.stages = data.tableData;
        const res = await Projects.updateOrderRoute(data.project, route);
        const { queryParams } = store.state;
        let allProjects = await Projects.allProjects();
        allProjects = filter(allProjects, { isTemplateProject: false });
        store.commit("setQueryParams", { allLocations: "" });
        if (res._id === queryParams.project._id) {
          store.commit("setQueryParams", { project: res });
        }
        data.project = res;
        const updateFields = [
          "projects",
          "projectsAndGI",
          "_projects",
          "_projectsAndGI",
        ];
        if (isEmpty(res.createdCompany._id) && (typeof res.createdCompany === 'string')) {
          res.createdCompany = {_id: res.createdCompany}
        }
        updateFields.forEach((key) => {
          const projectIdx = findIndex(queryParams[key], { _id: res._id });
          if (projectIdx > -1) {
            queryParams[key][projectIdx] = res;
            store.commit("setQueryParams", { [key]: queryParams[key] });
          }
        });
        buildTabsAndData();
        data.editMode = false;
        data.rerenderKey++;
        if (res.status === 200) {
          toast.success("Updated successfully");
        }
      } catch (e) {
        console.error(e);
      } finally {
        data.isLoading = false;
      }
    };
    
    const openActivityLog = () => {
      data.isActivityLogOpen = true;
    };

    onMounted(async () => {
       data.activityDetail.id = data.project._id;
       data.activityDetail.projectId = data.project._id;
       data.activityDetail.orderName = data.project.name;
    })

    const isDisabledOnPermission = computed(() => {
      return getPermissionValues({
        permissionModule: 'app&projects',
        type: 'alterProject',
      })
    })

    return {
      ...toRefs(data),
      openActivityLog,
      getModule,
      getIcon,
      setData,
      getData,
      alteredTableCols,
      setEditMode,
      save,
      getSubTitle,
      isDisabledOnPermission,
    };
  },
};
</script>
